import React, {useEffect,useId,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import './SearchFilterPanel.css';

export default function SearchFilterPanel({children,onApply,busy,count=0}) {
  const [open,setOpen]=useState(false);
  const id=useId(),panel=useRef(null),trigger=useRef(null);
  const apply=()=>{
    const invalid=[...panel.current.querySelectorAll('input,select,textarea')].find(field=>!field.checkValidity());
    if(invalid){invalid.reportValidity();return;}
    setOpen(false);onApply();
  };
  useEffect(()=>{
    if(!open)return undefined;
    const previous=document.body.style.overflow,triggerElement=trigger.current;document.body.style.overflow='hidden';
    panel.current?.querySelector('button')?.focus({preventScroll:true});
    const key=event=>{
      if(event.key==='Escape'){event.preventDefault();setOpen(false);}
      if(event.key==='Tab'){
        const items=[...panel.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),summary')].filter(e=>e.getClientRects().length);
        const first=items[0],last=items.at(-1);
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    };
    document.addEventListener('keydown',key);
    return()=>{document.body.style.overflow=previous;document.removeEventListener('keydown',key);triggerElement?.focus({preventScroll:true});};
  },[open]);
  return <>
    <button ref={trigger} className="search-more-filters" type="button" aria-haspopup="dialog" aria-expanded={open} aria-controls={id} onClick={()=>setOpen(true)}>More filters {count>0&&<span>{count}</span>} <span aria-hidden="true">＋</span></button>
    {open&&createPortal(<div className="search-filter-overlay" onMouseDown={e=>{if(e.target===e.currentTarget)setOpen(false);}}>
      <section ref={panel} id={id} role="dialog" aria-modal="true" aria-labelledby={id+'-title'} className="search-filter-panel" onKeyDown={event=>{if(event.key==='Enter'&&event.target.tagName==='INPUT'){event.preventDefault();if(!busy)apply();}}}>
        <header><div><h2 id={id+'-title'}>Refine your search</h2><p>Choose what matters. Everything else stays optional.</p></div><button type="button" aria-label="Close filters" onClick={()=>setOpen(false)}>×</button></header>
        <div className="search-filter-fields">{children}</div>
        <footer><button type="button" onClick={()=>setOpen(false)}>Done</button><button type="button" disabled={busy} onClick={apply}>Show homes</button></footer>
      </section>
    </div>,document.body)}
  </>;
}
